import { render, staticRenderFns } from "./Datatable.vue?vue&type=template&id=1a5652bb"
import script from "./DatatableScript.js?vue&type=script&lang=js&external"
export * from "./DatatableScript.js?vue&type=script&lang=js&external"
import style0 from "./Datatable.vue?vue&type=style&index=0&id=1a5652bb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports